var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupernovaGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 315,
    viewBox: "0 0 315 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_179_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.5 8L163.479 127.441L214.711 19.38L174.527 132.018L263.212 51.7875L182.982 140.473L295.62 100.289L187.559 151.521L307 157.5L187.559 163.479L295.62 214.711L182.982 174.527L263.212 263.212L174.527 182.982L214.711 295.62L163.479 187.559L157.5 307L151.521 187.559L100.289 295.62L140.473 182.982L51.7875 263.212L132.018 174.527L19.38 214.711L127.441 163.479L8 157.5L127.441 151.521L19.38 100.289L132.018 140.473L51.7875 51.7875L140.473 132.018L100.289 19.38L151.521 127.441L157.5 8Z",
    fill: "url(#paint0_radial_179_449)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_179_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.5 52.7969L160.302 136.219L184.599 56.3645L165.714 137.669L209.851 66.8243L170.566 140.47L231.535 83.4634L174.528 144.433L248.175 105.148L177.33 149.285L258.634 130.4L178.78 154.697L262.202 157.499L178.78 160.301L258.634 184.598L177.33 165.713L248.175 209.85L174.528 170.565L231.535 231.535L170.566 174.527L209.851 248.174L165.714 177.329L184.599 258.633L160.302 178.779L157.5 262.201L154.698 178.779L130.401 258.633L149.286 177.329L105.149 248.174L144.434 174.527L83.4644 231.535L140.471 170.565L66.8253 209.85L137.67 165.713L56.3655 184.598L136.22 160.301L52.7979 157.499L136.22 154.697L56.3655 130.4L137.67 149.285L66.8253 105.148L140.471 144.433L83.4644 83.4634L144.434 140.47L105.149 66.8243L149.286 137.669L130.401 56.3645L154.698 136.219L157.5 52.7969Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_179_449",
    x: 0,
    y: 0,
    width: 315,
    height: 315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_179_449"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_179_449",
    x: 44.7979,
    y: 44.7969,
    width: 225.404,
    height: 225.404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_179_449"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_179_449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.5 157.5) rotate(89.8422) scale(189.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFF2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F8D700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupernovaGlow);
export default __webpack_public_path__ + "static/media/supernova-glow.a3ac186ea5d0bb7e7f73c494ecfc03cd.svg";
export { ForwardRef as ReactComponent };